import React from "react";
import { useIntl } from "react-intl";
import { Checkbox, FormControlLabel, Grid, Stack, Typography } from "@mui/material";
import { OverrideCountChip, SectionHeader } from "../../components/primitives";
import { countAddressOverrides } from "../../model/overrideModel";
import { ui } from "../../styles";
import AddressFields from "./AddressFields";

const AddressStep = ({ fetchedCard, draftCard, moveAddressLine, setAddressFieldSetting, setAddressFieldValue, setDeliverySameAsBilling, updateAddress }) => {

  const intl = useIntl(), t = (id, values) => intl.formatMessage({ id }, values), addressOverrideCount = countAddressOverrides(draftCard, fetchedCard);
  const sameAsBillingChanged = fetchedCard && typeof draftCard.deliverySameAsBilling === "boolean" && draftCard.deliverySameAsBilling !== fetchedCard.deliverySameAsBilling;
  const common = { moveAddressLine, setAddressFieldSetting, setAddressFieldValue, updateAddress };

  const deliveryHeaderControl = <Stack direction="row" spacing={.35} alignItems="center">
    <FormControlLabel sx={{ m: 0, whiteSpace: "nowrap", "& .MuiFormControlLabel-label": { lineHeight: 1.2 } }}
      control={<Checkbox size="small" checked={draftCard.deliverySameAsBilling} onChange={event => setDeliverySameAsBilling(event.target.checked)} sx={{ p: .35, mr: .35 }} />}
      label={<Typography sx={{ color: ui.text, fontSize: 9.5, fontWeight: 550 }}>{t("admin.crm.customerCard.addresses.sameAsBilling")}</Typography>} />
    {sameAsBillingChanged && <OverrideCountChip count={1} label={t("admin.crm.customerCard.override.changed")} />}
  </Stack>;

  return <>
    <SectionHeader title={t("admin.crm.customerCard.addresses.title")} description={t("admin.crm.customerCard.addresses.description")} />
    {addressOverrideCount > 0 && <Stack direction="row" justifyContent="flex-end" sx={{ mt: -.75, mb: .55 }}><OverrideCountChip count={addressOverrideCount} label={t("admin.crm.customerCard.addresses.changeCount", { count: addressOverrideCount })} /></Stack>}
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}><AddressFields
        {...common}
        address={draftCard.invoiceAddress}
        addressSettings={draftCard.invoiceAddressSettings}
        addressType="invoiceAddress"
        masterAddress={fetchedCard?.invoiceAddress}
        masterAddressSettings={fetchedCard?.invoiceAddressSettings}
      />
      </Grid>
      <Grid item xs={12} md={6}>
        <AddressFields   {...common}
          address={draftCard.deliveryAddress}
          addressSettings={draftCard.deliveryAddressSettings}
          addressType="deliveryAddress"
          contentDisabled={draftCard.deliverySameAsBilling}
          headerControl={deliveryHeaderControl}
          masterAddress={fetchedCard?.deliveryAddress}
          masterAddressSettings={fetchedCard?.deliveryAddressSettings} /></Grid>
    </Grid>
  </>;
};

export default AddressStep;
